const bootstrap = require("bootstrap5/dist/js/bootstrap.bundle.min.js");

document.addEventListener("DOMContentLoaded", () => {
  const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-toggle="tooltip"]'));
  tooltipTriggerList.map(
    (tooltipTriggerEl) =>
      new bootstrap.Tooltip(tooltipTriggerEl, {
        template:
          '<div class="tooltip ml-2" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner text-left"></div></div>', // defaultにtext-left追加して左揃えに
      })
  );
});
